// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary_container__GBt8O","button":"ErrorBoundary_button__KEEft"};